module.exports = __webpack_public_path__ + "static/agile-organization-5e7f8e46a17695d7b737e99ec76e7584.jpg";